import React from 'react'
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ContactUs = () => {
        const eventData = useSelector((state) => state.event.eventData);
        const contact = eventData.people|| [];
        const backgroundImage = eventData.people.imageKey;
  return (
    <div >
         <section class="tour-area position-relative bg-top-center overflow-hidden space" id="service-sec"
 style={{
    backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
  
   >
 
 <div class="container" >
     <div class="row">
         <div class="col-lg-6 offset-lg-3" >
             <div class="title-area text-center">
                 <h2 class="sec-title">{contact.Heading
                 }</h2>
                 <span class="sub-title">{contact.subHeading}</span>
             </div>
           
         </div>
     </div>
     
 </div>

</section>
   <section class="tour-area position-relative bg-top-center overflow-hidden space" id="service-sec" style={{ background: "rgba(243, 240, 216, 1)" }}>
     
     <div class="container">
         <div class="row">
             <div class="col-lg-6 offset-lg-3">
                 
                 <div className="header-button" style={{justifyContent:"center"}}>
                  
                    <Link to="/community" className="th-btn">
                    Join WhatsApp Community
                    </Link>
                  </div>
             </div>
         </div>
         
     </div>

 </section>
 <div class="space">
        <div class="container">
            <div class="title-area text-center">
                <span class="sub-title">Get In Touch</span>
                <h2 class="sec-title">Our Contact Information</h2>
            </div>
            <div class="row gy-4 justify-content-center">
                <div class="col-xl-4 col-lg-6">
                    <div class="about-contact-grid style2">
                        <div class="about-contact-icon">
                            <img src="assets/img/icon/location-dot2.svg" alt=""/>
                        </div>
                        <div class="about-contact-details">
                            <h6 class="box-title">Our Address</h6>
                            <p class="about-contact-details-text" style={{color:"black"}}>
                                {contact.address}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6">
                    <div class="about-contact-grid">
                        <div class="about-contact-icon">
                            <img src="assets/img/icon/call.svg" alt=""/>
                        </div>
                        <div class="about-contact-details">
                            <h6 class="box-title">Phone Number</h6>
                            <p class="about-contact-details-text"><a href="tel:7520123555"> {contact.title}</a></p>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6">
                    <div class="about-contact-grid">
                        <div class="about-contact-icon">
                            <img src="assets/img/icon/mail.svg" alt=""/>
                        </div>
                        <div class="about-contact-details">
                            <h6 class="box-title">Email Address</h6>
                            <p class="about-contact-details-text"><a href="mailto:info@dronetv.in">{contact.email}</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
  )
}

export default ContactUs